module.exports = __webpack_public_path__ + "img/9788932910536.c50be0c4.jpg";